import { render, staticRenderFns } from "./ShiftsEstimates.vue?vue&type=template&id=cab326ba&lang=pug"
import script from "./ShiftsEstimates.vue?vue&type=script&lang=js"
export * from "./ShiftsEstimates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports